import { useQuery } from '@tanstack/react-query';

import { useFieldOnly, useProject } from '../projects/context';
import { projectKeys, useProjectApi } from '../projects/useProjectApi';

// useOrderPricePartner: Ist der angemeldete Makler Partner im Auftragspreis (Konzept 10)? Dann sieht er seine Preisliste.
export function useOrderPricePartner(): boolean {
  const { project } = useProject();
  const papi = useProjectApi();
  const fieldOnly = useFieldOnly();
  const q = useQuery({
    queryKey: projectKeys.myBrokerContract(project.id),
    queryFn: ({ signal }) => papi.myBrokerContract(signal),
    enabled: fieldOnly,
    staleTime: 5 * 60_000,
    retry: false,
  });
  return fieldOnly && q.data?.current?.model === 'ORDER_PRICE';
}
